export default "<img class=\"file-upload-image\" *ngIf=\"image\" src=\"{{image}}\" alt=\"\" [ngClass]=\"classList\"/>"